export default function Button({ children, variant = 'gold', className = '', disabled, ...props }) {
  const base = 'font-bold rounded-full transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed';

  const variants = {
    gold: 'btn-gold',
    outline: 'btn-outline',
    valentine: 'btn-valentine',
    ghost: 'text-royal-50 hover:text-gold py-2 px-4',
    danger: 'bg-red-600 hover:bg-red-700 text-white py-3 px-8',
    small: 'btn-gold text-sm py-2 px-4',
  };

  return (
    <button
      className={`${base} ${variants[variant] || variants.gold} ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}
